import React, { Component, useRef, useState, useEffect } from "react";
import { RouteComponentProps } from "react-router";
import {
  Spinner,
  Button,
  Divider,
  FormGroup,
  InputGroup,
  Card
} from "@blueprintjs/core";
import styled from "styled-components";
import { SaferEval } from "safer-eval";

const ViewerContainer = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const CanvasPreview = styled.div`
  background: #000;
  border-radius: 3px;
  width: 500px;
  height: 500px;
  canvas {
    width: 100%;
    height: 100%;
    image-rendering: optimizeSpeed;
    image-rendering: -moz-crisp-edges;
    image-rendering: -webkit-optimize-contrast
    image-rendering: -o-crisp-edges;
    image-rendering: crisp-edges;
    -ms-interpolation-mode: nearest-neighbor;
    image-rendering: -moz-crisp-edges;
    image-rendering: -webkit-crisp-edges
    image-rendering: pixelated;
  }
`;

interface Props {
  document: {
    data: string;
    script: string;
    type: boolean;
  };
  switchArt: () => void;
}

const ScriptEditor: React.SFC<Props> = ({ document, switchArt }) => {
  const persistentRef = React.useRef<object>({});

  const canvasRef = useRef(null);
  useEffect(() => {
    let canvas = canvasRef.current;
    let canvasContext = canvas.getContext("2d");
    canvasContext.webkitImageSmoothingEnabled = false;
    canvasContext.mozImageSmoothingEnabled = false;
    canvasContext.imageSmoothingEnabled = false;
    let timeoutLoop;

    const context = {
      persistent: persistentRef.current,
      context: canvasContext
    };
    const safer = new SaferEval(context);

    const render = () => {
      try {
        safer.runInContext("(function(){" + document.script + "})()");
      } catch (error) {
        console.log(error);
      }
      timeoutLoop = setTimeout(render, 1000 / 30)
    };

    render();

    return () => {
      clearTimeout(timeoutLoop);
    };
  });

  return (
    <ViewerContainer>
      <div>
        <CanvasPreview>
          <canvas ref={canvasRef} width={32} height={32} />
        </CanvasPreview>
        <br />
        <Card>
          <p>Currently playing script animation.</p>
          <Button onClick={() => switchArt()}>Switch panel to pixel editor</Button>
        </Card>
      </div>
    </ViewerContainer>
  );
};

export default ScriptEditor;
